module.exports = __webpack_public_path__ + "static/media/evaluate-not-helpful-new.5dd2aefc.svg";